module.exports = __webpack_public_path__ + "static/media/news-cm-allergy.3b621b04.png";